import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import type MailSwipeAction from 'owa-service/lib/contract/MailSwipeAction';
import strings from 'owa-strings/owa-mini-strings';
import { getIsPinned } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { getIsUnflagged, getIsUnread } from 'mini-mail-list-store/lib/utils/getTriageState';

export const getMailSwipeActionName = (swipeActionName: MailSwipeAction): string => {
    switch (swipeActionName) {
        case 0:
            return 'None';
        case 1:
            return 'Delete';
        case 2:
            return 'Archive';
        case 5:
            return 'ToggleFlag';
        case 3:
            return 'TogglePin';
        case 4:
            return 'ToggleRead';
    }
};

export const getSwipeActionText = (swipeActionName: MailSwipeAction, rowId: string): string => {
    const tableView = getSelectedTableView();
    switch (swipeActionName) {
        case 1:
            return strings.deleteItem;
        case 2:
            return strings.archiveText;
        case 3:
            return getIsPinned(rowId, tableView) ? strings.unpinText : strings.pinText;
        case 5:
            return getIsUnflagged(rowId) ? strings.flag : strings.unflag;
        case 4:
            return getIsUnread(rowId) ? strings.markReadText : strings.markUnreadText;
    }

    return undefined;
};

export const getSwipeActionBackground = (swipeActionName: MailSwipeAction): string => {
    switch (swipeActionName) {
        case 1:
            return 'mailListItem-swipeAction--deleteEnabled';
        case 2:
            return 'mailListItem-swipeAction--archiveEnabled';
        case 3:
            return 'mailListItem-swipAction--pinEnabled';
        case 5:
            return 'mailListItem-swipeAction--flagEnabled';
        case 4:
            return 'mailListItem-swipeAction--markAsEnabled';
    }

    return undefined;
};

export const getSwipeActionName = (isLeftSwipe: boolean): MailSwipeAction => {
    const configuration = getUserConfiguration().ViewStateConfiguration;
    return isLeftSwipe ? configuration.MailRightSwipeAction : configuration.MailLeftSwipeAction;
};
